<template>
  <div>
    <div class="custom-select-box d-inline-block multi-select" :tabindex="tabindex" ref="select-box">
      <input class="selected" placeholder="Add / search tags" @click="toggleDropdown" />
      <div ref="options" class="items" v-if="isDropdownVisible" v-bind:class="{ show: isDropdownVisible }" v-click-outside="closeDropdown">
        <div>
          <input type="text" class="search-bar" :class="{ error: errorMessage }" placeholder="Add / search tags" v-model="searchOption" />
          <button data-testid="add-group-tag-button" type="button" class="add-button" v-if="showAddButton && !showAddButtonVisible" @click="addNewOption()" :class="!!searchOption ? '' : 'disable-add-button'">Add</button>
        </div>
        <div class="error-message">{{ errorMessage }}</div>
        <div class="horizontal-divider"></div>
        <div class="multi-select-height">
          <div v-if="filteredOptions.length > 0">
            <div class="item" v-for="option of filteredOptions" :key="`multiple-choice-option-${option.name}`">
              <label class="select-options">
                <input :id="option.name" :value="{ name: option.name }" type="checkbox" v-model="selectedOptions" />
                <span class></span>
                {{ option.name }}
              </label>
            </div>
          </div>
          <div v-else class="empty-options" v-html="noDataHTML"></div>
        </div>
      </div>
    </div>
    <div class="pt-10" v-if="showSelectedOptions">
      <div v-if="sortedSelectedOptions.length" class="selected-options-chips">
        <span v-for="(opt, index) in sortedSelectedOptions" :key="index" class="chip"
          >{{ opt.name }}
          <span @click="$delete(sortedSelectedOptions, index)" class="fa fa-times-circle"></span>
        </span>
      </div>
    </div>
  </div>
</template>
<script>
import { cloneDeep } from "lodash";
export default {
  directives: {
    "click-outside": {
      bind(el, binding, vnode) {
        el.clickOutsideEvent = function(event) {
          if (!(el == event.target || el.contains(event.target))) {
            vnode.context[binding.expression]();
          }
        };
        document.body.addEventListener("click", el.clickOutsideEvent);
      },
      unbind(el) {
        document.body.removeEventListener("click", el.clickOutsideEvent);
      }
    }
  },
  name: "MultiSelectWithSearch",
  props: {
    options: {
      type: Array,
      required: true
    },
    tabindex: {
      type: Number,
      required: false,
      default: 0
    },
    selectedOptionList: {
      default: () => [],
      type: Array
    },
    placeholder: {
      type: String,
      required: true
    },
    showAddButton: {
      type: Boolean,
      required: false,
      default: false
    },
    noDataHTML: {
      type: String,
      required: false,
      default: "<span>Data not found. <br> Click “Add” to create new data.</span>"
    },
    showSelectedOptions: {
      type: Boolean,
      required: false,
      default: false
    }
  },
  watch: {
    selectedOptions: {
      deep: true,
      handler(value) {
        this.$emit("onSelect", value);
      }
    }
  },
  data() {
    return {
      selectedOptions: cloneDeep(this.selectedOptionList),
      searchOption: "",
      optionList: cloneDeep(this.options),
      isDropdownVisible: false,
      errorMessage: ""
    };
  },
  computed: {
    showAddButtonVisible() {
      if (this.searchOption && !/^[a-zA-Z_][a-zA-Z0-9_ ]*$/.test(this.searchOption.trim())) {
        this.errorMessage = "Group tag names cannot start with a number or contain non-alphanumeric characters.";
        return true;
      } else {
        this.errorMessage = "";
      }
      if (this.optionList.length > 0) {
        if (this.searchOption) {
          return this.optionList.some(option => option.name.toLowerCase() === this.searchOption.trim().toLowerCase());
        } else {
          return true;
        }
      }
      return false;
    },
    filteredOptions() {
      this.optionList.sort(({ name: a }, { name: b }) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1));
      if (this.searchOption && this.optionList.length) {
        return this.optionList.filter(item => {
          return item.name.toLowerCase().startsWith(this.searchOption.trim().toLowerCase());
        });
      }
      return this.optionList;
    },
    sortedSelectedOptions() {
      return this.selectedOptions.sort(({ name: a }, { name: b }) => (a.toLowerCase() < b.toLowerCase() ? -1 : 1));
    }
  },
  methods: {
    closeDropdown() {
      this.isDropdownVisible = false;
      this.searchOption = "";
      this.errorMessage = "";
    },
    toggleDropdown() {
      this.isDropdownVisible = !this.isDropdownVisible;
      this.searchOption = "";
      this.errorMessage = "";
    },
    addNewOption() {
      // double check group tag name empty validation (backward compatibility)
      if (!this.searchOption) {
        return;
      }
      // double check group tag name validation (backward compatibility)
      if (!/^[a-zA-Z_][a-zA-Z0-9_ ]*$/.test(this.searchOption.trim())) {
        this.errorMessage = "Group tag names cannot start with a number or contain non-alphanumeric characters.";
        return;
      }

      let newObject = {
        name: this.searchOption.trim()
      };
      this.optionList.unshift(newObject);
      this.selectedOptions.push(newObject);
      this.searchOption = "";
      this.errorMessage = "";
    },
    prepareSelectedOptions() {
      this.selectedOptions = this.selectedOptions.map(option => ({ name: option.name }));
    }
  },
  mounted() {
    this.prepareSelectedOptions();
  }
};
</script>

<style lang="scss" scoped>
.custom-select-box {
  position: relative;
  width: 100%;
  text-align: left;
  outline: none;
  font-size: 12px;
  font-weight: normal;
  .selected {
    background-color: #ffffff;
    border-radius: 4px;
    border: none;
    color: #4a4a4a;
    padding: 7px;
    padding-left: 11px;
    cursor: pointer;
    user-select: none;
    text-transform: capitalize;
    width: 100%;
  }

  .items {
    color: #4a4a4a;
    border-radius: 4px;
    position: absolute;
    background-color: #ffffff;
    left: 0px;
    right: 0px;
    top: 0px;
    box-shadow: 0 4px 12px 0 rgba(0, 0, 0, 0.25);
    z-index: 1;
    min-width: 316px;
    max-height: 500px;
    padding: 16px;
    font-size: 14px;

    scrollbar-width: thin;
    /* "auto" or "thin"  */
    scrollbar-color: #e6e9ed transparent;

    /* scroll thumb & track */
    &::-webkit-scrollbar {
      width: 7px;
      /* width of the entire scrollbar */
    }

    &::-webkit-scrollbar-track {
      background: transparent;
      /* color of the tracking area */
    }

    &::-webkit-scrollbar-thumb {
      background-color: #c5d1d6;
      /* color of the scroll thumb */
      border-radius: 20px;
      /* roundness of the scroll thumb */
      border: 3px solid transparent;
      /* creates padding around scroll thumb */
    }

    .item {
      cursor: pointer;
      user-select: none;
      margin-bottom: 4px;
      &:hover {
        background-color: #f8f9fa;
      }
      &:last-of-type {
        margin-bottom: 0;
      }

      /*checkbox data*/

      label {
        width: 100%;
        cursor: pointer;

        span {
          vertical-align: middle;
          margin-right: 5px;
          width: auto;
        }
      }

      input[type="checkbox"] {
        display: none;
        height: 16px;
        width: 16px;
      }

      input[type="checkbox"] + span:before {
        content: "";
        border: 0.1em solid #959fa4;
        border-radius: 4px;
        width: 16px;
        height: 16px;
        padding: 4px;
        color: transparent;
        background-color: #fff;
        background-repeat: no-repeat;
        background-position: center center;
        display: inline-block;
        margin-top: 2px;
      }

      input[type="checkbox"]:checked + span:before {
        background-color: #4c8ce4;
        border: 0.1em solid #4c8ce4;
        color: #fff;
        background-image: url(/static/img/checked-checkbox.svg);
      }
    }
  }
}

.selectHide {
  display: none;
}

.placeholder-text {
  font-size: 14px;
  line-height: 1.43;
  letter-spacing: normal;
  text-align: left;
  color: #979797;
}

.search-bar {
  border-radius: 4px;
  border: solid 1px #b0bac9;
  background-color: #ffffff;
  width: 275px;
  height: 37px;
  padding-right: 50px;
  &.error {
    border: solid 1px #f16559;
  }
}
.error-message {
  font-size: 12px;
  font-weight: 500;
  color: #f16559;
}
.multi-select-height {
  overflow-x: hidden;
  overflow-y: auto;
  height: 190px;
  padding-top: 10px;
}
.add-button {
  margin-left: -56px;
  height: 25px;
  width: 50px;
  border: solid 1px #4c8ce4;
  background-color: #4c8ce4;
  color: white;
  padding: 2px 4px;
  border-radius: 4px;
  cursor: pointer;
}

.empty-options {
  font-size: 12px;
  font-weight: normal;
  font-stretch: normal;
  font-style: normal;
  line-height: 1.67;
  letter-spacing: normal;
  text-align: center;
  color: #666669;
}
.disable-add-button {
  opacity: 0.5;
}

.horizontal-divider {
  height: 15px;
  border-bottom: 1px solid #d3dee3;
  width: 316px;
  margin-left: -16px;
}

.selected-options-chips {
  font-size: 12px;
  vertical-align: middle;

  .chip {
    padding: 5px 12px;
    border-radius: 4px;
    color: #4a4a4a;
    background-color: #e0e0e0;
    margin-right: 10px;
    margin-bottom: 4px;
    display: inline-block;

    .fa {
      color: #666669;
      vertical-align: middle;
      cursor: pointer;
      font-size: 15px;
      margin-left: 5px;
    }

    &:last-of-type {
      margin-right: 0;
    }
  }
}

.multi-select {
  width: 232px;
  border-radius: 4px;
  border: solid 1px #d3dfe4;
  background-color: #fff;
}
</style>
